import { Component } from '@angular/core';
import { PlantService } from '../services/plant.service';
import { Product } from 'app/models/Product';

@Component({
  selector: 'app-plants',
  templateUrl: './plants.component.html',
  styleUrls: ['./plants.component.scss']
})
export class PlantsComponent {
  plants: Product[] = [];
  pagination: any = {};
  currentPage = 1;
  perPage = 25;
  category = '';
  orderBy = '';
  keyword = '';
  packagingType = '';

  constructor(private plantService: PlantService) {}

  ngOnInit() {
    this.fetchPlants(this.currentPage, this.perPage, this.category, this.orderBy, this.keyword, this.packagingType);
  }

  fetchPlants(page: number, perPage: number, category: string, orderBy: string, keyword: string, packagingType: string) {
    this.plantService.getPlantData(page, perPage, category, orderBy, keyword, packagingType).subscribe({
      next: ({ plants, pagination }) => {
        this.plants = plants;
        this.pagination = pagination;
        this.currentPage = pagination.current_page;
      },
      error: err => {
        console.error('Error fetching plant data:', err);
      }
    });
  }

  onPageChange(page: number) {
    this.fetchPlants(page, this.perPage, this.category, this.orderBy, this.keyword, this.packagingType);
  }

  onPerPageChange(perPage: number) {
    this.perPage = perPage;
    this.fetchPlants(1, this.perPage, this.category, this.orderBy, this.keyword, this.packagingType);
  }

  onFilterChange(filter: any) {
    this.category = filter.category;
    this.orderBy = filter.orderBy;
    this.keyword = filter.keyword;
    this.packagingType = filter.packaging_type;
    this.fetchPlants(this.currentPage, this.perPage, this.category, this.orderBy, this.keyword, this.packagingType);
  }
}
